export class SearchCondition {
  lesson_code: string = ""
  name: string = ""
  nendo: string = ""
  subject_code: string = null
  page: number = 1
  row_count: number =  100
}

export class Lesson {
  id: number
  lesson_code: string
  name: string
  nendo: number
  subject_code: string
  subject_name: string
  tantou_login_id: number
  user_name: string
  goal_comment: string
  message: string
  is_checked: boolean = false

  constructor(x: any){
    this.id = x.id
    this.lesson_code = x.lesson_code
    this.name = x.name
    this.nendo = x.nendo
    this.subject_code = x.subject_code
    this.subject_name = x.subject_name
    this.tantou_login_id = x.tantou_login_id
    this.user_name = x.user_name
    this.goal_comment = x.goal_comment
    this.message = x.message
  }
}